import tw from "twin.macro"
import dynamic from "next/dynamic"

import API from "lib/api"
import withSSRUser from "lib/withSSRUser"
import checkPageDataAuth from "lib/checkPageDataAuth"

import { MetaFields } from "components/Metadata"
import Zone, { locationQuery } from "components/dynamic/Zone"

const HeroLocation = dynamic(import("components/Heroes/HeroLocation"))

export default function LocationPage({ pageData, weatherData }) {
  const { Hero, LFLNameID } = pageData
  return (
    <>
      {Hero && (
        <HeroLocation
          {...Hero}
          WeatherData={weatherData}
          LFLNameID={LFLNameID}
        />
      )}
      <Zone DynamicZone={pageData?.DynamicZone || []} />
    </>
  )
}

export const getServerSideProps = withSSRUser(async ({ params }) => {
  const { HeroLocationQuery } = await import("components/Heroes/HeroLocation")
  try {
    const { data, response } = await API.gql(
      `{
      locationPages
      (
        where: { UID: "${params.location}" }
      ) 
      {
        UID
        id
        LFLNameID
        ${MetaFields}
        Hero ${HeroLocationQuery.fields}
        DynamicZone ${locationQuery.query}
      }
    }`,
      locationQuery.fragments
    )

    const authRedirect = checkPageDataAuth(data, `location/${params.location}`)
    if (authRedirect) {
      return authRedirect
    }

    const [{ data: theme }, { data: nav }] = await Promise.all([
      API.cachedGet("/theme", 60000),
      API.cachedGet("/navigation", 60000),
    ])

    if (!response.ok) {
      console.log(locationQuery.query, locationQuery.fragments)
    }

    const pageData = data?.data?.locationPages?.[0] || {}

    if (!pageData.UID) {
      return {
        notFound: true,
      }
    }
    const url = `https://api.openweathermap.org/data/2.5/weather?lat=${pageData?.Hero?.Latitude}&lon=${pageData?.Hero?.Longitude}&appid=${process.env.NEXT_WEATHER_KEY}&units=metric`
    const weatherResponse = await fetch(url).then((res) => res.json())
    const weatherData = weatherResponse.weather
      ? {
          type: weatherResponse.weather[0]?.main,
          temp: Math.round(weatherResponse.main?.temp),
          typeId: weatherResponse.weather[0]?.id,
        }
      : {}

    return {
      props: {
        pageData,
        theme,
        nav,
        weatherData,
      },
    }
  } catch (e) {
    console.warn(e)
    return {
      notFound: true,
    }
  }
})
